export default __webpack_public_path__ + "static/media/student.20fe2c51.png";